// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    AmazonS3: 'https://s3.amazonaws.com/testlb.licenseusageparser.com',
	AmazonS3UploadLimit: '2 MB',
	AmazonS3BasicUploadLimit: '5 MB',
	AmazonS3AdvancedUploadLimit: '10 MB',
	AmazonS3PremiumUploadLimit: '20 MB',
  demoPlanUploadLimit: 2097152,
  basicPlanUploadLimit: 5242880,
  advancedPlanUploadLimit: 10485760,
	parseLineLimitLight: '2,000',
	parseLineLimitBasic: '10,000',
	paypalAdvancedPrice: '1200',
	paypalPremiumPrice: '25.00',
	paypalAdvancedPriceSinglePayment: '100',
	paypalPremiumPriceSinglePayment: '25.00',
    userInfoURL: 'https://ipinfo.io',
    baseURL: 'https://qa-parser.openlm.com/logparser',
      captcha: {
        // captcha site key
        siteKey: '6LfFtigUAAAAACGALTOjQqWdoYNRp133Wut1HAvH'
      },
    account: '/api/account',
    admin: '/api/admin/',
    auth: '/api/auth',
    login: '/api/login',
    devmode: '/api/devmode',
    feedback: '/api/feedback',
    signup: '/api/signup',
    report: '/api/report',
    reportChart: '/api/report/chart',
    parser: '/api/parser',
    zoho: '/api/zoho',
    webSocket: 'wss://qa-parser.openlm.com/logparser/ws/parser/progress',
    zohoVisitTracker: 'https://crm.zohopublic.com/crm/WebFormAnalyticsServlet?rid=2b8e26fec83821e61c237359389efa91d858313c49210815c9b8eafb45d46e3816f0771d30545d4948b4d33d19f693e1gid8d5e016eab63b3146c9f644da751d4eebab74543b236856140cb1614539848dbgid107d71cab20c2e0d91fd6b3ff6002a825eb61b346f8ae5e6da2d92420a30654egidb322b81c74b4d65a3f61bf4a0bcf8e37ed96f0d1bd4f373389fe7072ef7755e1gid017ba5ccdf02618eda1091a504897dd7669adfa2863bbb000427a57a71bd69fa&tw=ca2b64ac4b62f4f2e42fd7cba6a9daaf462ccc1eb18b97c4e67ab9348fc1100d&la=7472ec73e806b02ac405b316e2884e95fc8b4e8df4769279f17f7b20af2491cf&pwXsmCp=https%3A%2F%2Falllicenseparser.com%2F%23%2Fhome',
    ipGeolocationService: 'https://ipapi.co/json/',
    intlTelInputService:'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js'
};



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/environments/environment.ts